(function () {
  class WildFireAnim extends PIXI.Container {
    constructor() {
      super();

      messageBus.subscribe(
        "spinner:GameConfigEvent",
        this.onGameConfigEvent.bind(this)
      );
    }

    onGameConfigEvent() {
      this._shaker = resourceManager.get("slotShaker");
    }

    convertFireballsToFireballWilds(fireballs) {
      const symbols = resourceManager.getConfiguration().symbols;
      const firstCashFireballId = symbols["Symbol_BlueFireball20"].ID;
      const possibleValues = [20, 40, 60, 80, 100, 200, 300, 400, 500];

      let stake = gameController.getCurrentModeStake(true);

      fireballs.forEach(function (fireball) {
        const stakeIndependentValue =
          fireball.amount / (stake / gameData.numLines);
        const index = possibleValues.indexOf(stakeIndependentValue);
        if (index >= 0) {
          gameData.reels[fireball.reel].setReelSymbol(
            fireball.row,
            firstCashFireballId + index
          );
        }
      });
    }
  }

  var wildFireAnimCreator = function (json) {
    return new WildFireAnim();
  };

  var wildFireAnimInitialiser = function (json, wildFireAnim) {};

  var wildFireAnimFilesRequired = function () {
    return [];
  };

  resourceManager.registerObjectType(
    "wildFireAnim",
    wildFireAnimCreator,
    wildFireAnimInitialiser,
    wildFireAnimFilesRequired
  );
})();
